import Subsidiary from './subsidiaries';
export default Subsidiary;
